import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MaterialModule } from './material/material.module';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { CountryListComponent } from './country-list/country-list.component';
import { TimeSliderComponent } from './time-slider/time-slider.component';
import { MonthsValueComponent } from './months-value/months-value.component';
import { ChartsModule } from 'ng2-charts';
import { CharteComponent } from './charte/charte.component';
import { MapComponent } from "./map/map.component";
import { DataService } from './data.service';


@NgModule({
  declarations: [
    AppComponent,
    CountryListComponent,
    TimeSliderComponent,
    MonthsValueComponent,
    CharteComponent,
    MapComponent,
    CharteComponent
  ],
  imports: [
    BrowserModule,
    MaterialModule,
    AppRoutingModule,
    FormsModule,
    ChartsModule,
    BrowserAnimationsModule,
    HttpClientModule
  ],
  providers: [DataService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Workspace/hyblab-migration/src/app/app.module.ts